import {
	SESSION_FETCH_SUCCESS,
	COMPANIES_GET_ACTIVE_COMPANY_ID,
	COMPANIES_SET,
	COMPANIES_VALIDATE,
	COMPANIES_VALIDATE_SUCCESS,
	COMPANIES_VALIDATE_FAIL,
	COMPANIES_ADD,
	COMPANIES_ADD_SUCCESS,
	COMPANIES_ADD_FAIL,
	COMPANIES_REMOVE_SUCCESS,
	COMPANIES_UPDATE,
	COMPANIES_UPDATE_SUCCESS,
	COMPANIES_UPDATE_FAIL,
	COMPANIES_INDUSTRIES_FETCH,
	COMPANIES_INDUSTRIES_FETCH_SUCCESS,
	COMPANIES_INDUSTRIES_FETCH_FAIL,
	COMPANIES_SIZES_FETCH,
	COMPANIES_SIZES_FETCH_SUCCESS,
	COMPANIES_SIZES_FETCH_FAIL,
	COMPANIES_COUNTRIES_FETCH,
	COMPANIES_COUNTRIES_FETCH_SUCCESS,
	COMPANIES_COUNTRIES_FETCH_FAIL,
	COMPANIES_CHANGE,
	COMPANIES_CHANGED,
	COMPANIES_USER_ADD,
	COMPANIES_USER_ADD_SUCCESS,
	COMPANIES_USER_ADD_FAIL,
	COMPANIES_ESTIMATE_USER_ADD,
	COMPANIES_ESTIMATE_USER_ADD_SUCCESS,
	COMPANIES_ESTIMATE_USER_ADD_FAIL,
	COMPANIES_ESTIMATE_SEAT,
	COMPANIES_ESTIMATE_SEAT_SUCCESS,
	COMPANIES_ESTIMATE_SEAT_FAIL,
	COMPANIES_PURCHASE_SEAT,
	COMPANIES_PURCHASE_SEAT_SUCCESS,
	COMPANIES_PURCHASE_SEAT_FAIL,
	COMPANIES_USER_UPDATE,
	COMPANIES_USER_UPDATE_SUCCESS,
	COMPANIES_USER_UPDATE_FAIL,
	COMPANIES_ESTIMATE_USER_UPDATE,
	COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS,
	COMPANIES_ESTIMATE_USER_UPDATE_FAIL,
	COMPANIES_USER_DELETE,
	COMPANIES_USER_DELETE_SUCCESS,
	COMPANIES_USER_DELETE_FAIL,
	COMPANIES_ESTIMATE_USER_DELETE,
	COMPANIES_ESTIMATE_USER_DELETE_SUCCESS,
	COMPANIES_ESTIMATE_USER_DELETE_FAIL,
	COMPANIES_CREATE_CHARGEBEE_SESSION,
	COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS,
	COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL,
	COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION,
	COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS,
	COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL,
	COMPANIES_FONT_ADD,
	COMPANIES_FONT_ADD_FAIL,
	COMPANIES_FONT_REMOVE,
	COMPANIES_FONT_REMOVE_FAIL,
	COMPANIES_SMART_FIELDS_UPDATE,
	COMPANIES_SMART_FIELDS_UPDATE_FAIL,
	SEND_EMAIL,
	SEND_EMAIL_SUCCESS,
	SEND_EMAIL_FAIL,
	WORKSPACE_ADD_SUCCESS,
	WORKSPACE_DELETE_SUCCESS,
	SOCKET_SUBSCRIBE,
	REQUEST_FINISHED,
	COMPANIES_SETTING_WRITE,
	COMPANIES_SETTING_WRITE_SUCCESS,
	COMPANIES_SETTING_WRITE_FAIL,
	COMPANIES_INVITE_USER_ADD,
	COMPANIES_INVITE_USER_UPDATE,
	COMPANIES_INVITE_USER_REMOVE,
	COMPANIES_INVITE_USER_MESSAGE_SET,
	COMPANIES_INVITE_USER_CLEAR_USERS,
	COMPANIES_INVITE_USER_CLEAR_MESSAGE,
	USER_REDUCE_UPDATE,
	COMPANIES_USERS_REDUCE,
	COMPANIES_USERS_REDUCE_SUCCESS,
	COMPANIES_USERS_REDUCE_FAIL,
	ADDON_GET_DETAILS,
	ADDON_GET_DETAILS_SUCCESS,
	ADDON_GET_DETAILS_FAIL,
	UPCOMING_INVOICE_GET_ESTIMATE,
	UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS,
	UPCOMING_INVOICE_GET_ESTIMATE_FAIL,
	SUBSCRIPTION_GET_ESTIMATE,
	SUBSCRIPTION_GET_ESTIMATE_SUCCESS,
	SUBSCRIPTION_GET_ESTIMATE_FAIL,
	SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN,
	SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS,
	SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL,
	COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS,
	COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS,
	COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL,
	COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS,
	ERROR_HANDLER_SET,
	COMPANIES_CONTACT_SALES,
	COMPANIES_CONTACT_SALES_SUCCESS,
	COMPANIES_CONTACT_SALES_FAIL,
	DISCOUNT_CLEAR_APPLIED,
	USER_EXTERNAL_ID_UPDATE,
	USER_EXTERNAL_ID_UPDATE_SUCCESS,
	USER_EXTERNAL_ID_UPDATE_FAIL,
	USER_EXTERNAL_ID_STATE_CLEAR,
	USER_REGION_FETCH,
	USER_REGION_FETCH_SUCCESS,
	USER_REGION_FETCH_FAIL,
	COMPANIES_UPDATE_USER_PHOTO,
	COMPANIES_UPDATE_USER_PHOTO_FAIL,
	COMPANIES_UPDATE_USER_PHOTO_SUCCESS
} from './actions';
import { showQuickMessage } from 'redux/modules/quickMessages';
import { extractPropsforSuperagentHttpError, extractPropsforAxiosHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';
import { getItem, setItem } from '../../storage';
import store from '../../redux/store';
import { sendCurrentOfferToUser } from 'redux/modules/discount';

import { omit, findIndex } from 'lodash';
import {
	USER_ROLE_ADMIN,
	USER_ROLE_BASIC,
	USER_ROLE_GUEST,
	XC_URL,
	STATIC_RESOURCE_INDUSTRIES_PATH,
	STATIC_RESOURCE_COUNTRIES_PATH,
	STATIC_RESOURCE_SIZES_PATH,
	REDUCE_ACTION,
	PACKAGES_CONFIG,
	CONTACT_SALES,
	COUNTRY_DETECTION_ENDPOINT,
	ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT,
	SUBSCRIPTION_PLAN
} from '../../config';
import { getCompanyIdFromURL } from '../../utils/url';
import { filterNonGuestUsers } from '../../utils/users';
import {
	getSubscriptionsAndAddons,
	getNonObsoleteMemberAddonForPlan,
	convertPlanIdIntoSubscription
} from '../../utils/subscription';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import StaticResource from 'lib/StaticResource';
import Logger from '../../logger/logger';

const log = Logger.get('redux-companies');
const localize = i18n.loc.localize;

const initialState = {
	byId: null,					// {}
	rawDataById: null,			// {}
	allIds: null,				// []
	selectedId: undefined,		// ''
	valid: true,
	loading: false,
	companyIsUpdating: false,
	companyUpdatingErrorId: null,
	pendingPayingUserQuantity: 0,
	addonsDetails: {},
	// addon details related to paymentAccount of active/inactive subscription
	currentMemberAddonDetails: null,
	upcomingInvoiceEstimation: null,
	upcomingInvoiceEstimationXhrInProgress: false,
	subscriptionEstimation: null,
	subscriptionEstimationActivePlan: null,
	pendingReduceUsers: [],
	userRegion: null,
	sizes: [],
	industries: [],
	countries: [],
	inviteUsers: [],
	inviteUsersMessage: null,
	addCompanyUsersErrorId: null,

	estimateCostOnAddCompanyUsersErrorId: null,
	estimateCostOnAddUserSeatsErrorId: null,

	createChargeBeeSubscriptionErrorId: null,
	createChargeBeeSubscriptionSuccess: null,
	
	batchReduceUsersSuccess: null,
	batchReduceUsersErrorId: null,

	purchaseSeatsSuccess: null,
	purchaseSeatsErrorId: null,

	fetchAddonDetailsErrorId: null,
	fetchAddonDetailsSuccess: null,

	getUpcomingInvoiceEstimateErorId: null,
	getUpcomingInvoiceSuccess: null,

	getSubscriptionEstimateXhrInProgress: false,
	getSubscriptionEstimateUrl: null,
	getSubscriptionEstimateForPlan: null,
	getSubscriptionEstimateErrorId: null,
	getSubscriptionEstimateSuccess: null,

	getSubscriptionEstimateActivePlanXhrInProgress: false,
	getSubscriptionEstimateActivePlanErrorId: null,
	getSubscriptionEstimateActivePlanSuccess: null,	

	fetchCurrentMemberAddonDetailsXhrInProgress: false,
	fetchCurrentMemberAddonDetailsErrorId: null,
	fetchCurrentMemberAddonDetailsSuccess: null,

	contactSalesSuccess: null,
	contactSalesErrorId: null,
	contactSalesXhrInProgress: false,

	updatingExternalIdXhrInProgress: [],
	updatingExternalIdErrorId: [],
	updatingExternalIdSuccess: [],

	updatingUserPhotoInProgress: [],
	updatingUserPhotoErrorId: [],
	updatingUserPhotoSuccess: []
};

function getUserRole(company, userEmail) {
	let companyUser = company.users.filter((u) => u.email === userEmail);
	if (companyUser.length) {
		return companyUser[0].role;
	}
}


/**
 * Check if the current company has active trial or any paid plan
 *
 * @param { object } { trial, paymentAccount }
 * @returns { bool }
 */
function isCompanyActive(company) {
	const { subscription, perpetualAddons }	= getSubscriptionsAndAddons(company);

	const hasActiveTrial = company.trial && company.trial.endDate > Date.now();
	const hasActivePlan = !_.isEmpty(subscription) || !_.isEmpty(perpetualAddons);

	return Boolean(hasActiveTrial || hasActivePlan);
}

function hasTrial({ trial }) {
	return trial && trial.startDate <= Date.now() && trial.endDate > Date.now();
}

function getTrialDays({ trial }) {
	if (!hasTrial({ trial })) {
		return;
	}

	const ONE_DAY = 1000 * 60 * 60 * 24;
	const days = trial.endDate - Date.now();

	return days <= 0 ? 0 : Math.ceil(days / ONE_DAY);
}

const getCompany = (company, userEmail) => {
	const { _id: id, workspaces } = company;
	const { subscription, perpetualAddons, memberAddons } = getSubscriptionsAndAddons(company, true);
	const userRole = getUserRole(company, userEmail);

	return {
		id,
		...company,
		isActive: isCompanyActive(company),
		subscription,
		perpetualAddons,
		memberAddons,
		hasActiveSubscription: subscription && subscription.active,
		hasTrial: subscription && subscription.active ? null : hasTrial(company),
		trialDays: getTrialDays(company),
		email: company.email || '',
		address1: company.address1 || '',
		address2: company.address2 || '',
		city: company.city || '',
		region: company.region || '',
		postcode: company.postcode || '',
		country: company.country || '',
		phone: company.phone || '',
		website: company.website || '',
		industry: company.industry || null,
		industryId: company.industryId || '',
		size: company.size || '',
		workspaces: workspaces.map(workspace => workspace._id),
		userRole: userRole,
		userIsAdmin: userRole === USER_ROLE_ADMIN,
		userIsGuest: userRole === USER_ROLE_GUEST,
		_id: undefined,
		companySettingsUpdateSuccess: null
	};
};

const initializeFromSession = (state, session) => {
	let byId = {};
	let rawDataById = {};
	let allIds = [];
	const { companies, user } = session;

	for (const company of companies) {
		const { id, ...props } = getCompany({ ...company }, user.mainEmail);
		if ([USER_ROLE_ADMIN, USER_ROLE_BASIC].indexOf(props.userRole) > -1) {
			allIds.push(id);
			byId[id] = { id, ...props };
		}
		rawDataById[id] = { id, ...props };
	}

	return { byId, allIds, rawDataById };
};

const updateReducedUsers = (reduceUsersState, email, userId, externalIds, action) => {
	if (action === REDUCE_ACTION.KEEP_ROLE) {
		return reduceUsersState.filter(user => user.email !== email);

	} else if ([REDUCE_ACTION.CHANGE_TO_GUEST, REDUCE_ACTION.REMOVE].includes(action)) {
		const userExistsInReduceUsersArray = reduceUsersState.find(user => user.email === email); 

		if (userExistsInReduceUsersArray) {
			return reduceUsersState.map(user => {
				if (user.email === email) {
					return { email, action, userId, externalIds };
				} else {
					return user;
				}
			});
		} else {
			const newReduceUsersState = _.clone(reduceUsersState);
			newReduceUsersState.push({ email, action, userId, externalIds });
			return newReduceUsersState;
		}
	}
};

export default (state = initialState, action) => {

	switch (action.type) {
		case COMPANIES_GET_ACTIVE_COMPANY_ID:
			return {
				...state,
				selectedId: action.payload
			};

		case SESSION_FETCH_SUCCESS:
			return {
				...state,
				...initializeFromSession(state, action.result)
			};

		case COMPANIES_ESTIMATE_USER_ADD:
			return {
				...state,
				estimateCostOnAddCompanyUsersErrorId: null,
				loading: true
			};

		case COMPANIES_ESTIMATE_USER_ADD_FAIL:
			return {
				...state,
				estimateCostOnAddCompanyUsersErrorId: _.get(action, 'error.errorId'),
				loading: false
			};

		case COMPANIES_ESTIMATE_SEAT:
			return {
				...state,
				estimateCostOnAddUserSeatsErrorId: null,
				loading: true
			};

		case COMPANIES_ESTIMATE_SEAT_FAIL:
			return {
				...state,
				estimateCostOnAddUserSeatsErrorId: _.get(action, 'error.errorId'),
				loading: false
			};

		case COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS:
			return {
				...state,
				fetchCurrentMemberAddonDetailsErrorId: null,
				fetchCurrentMemberAddonDetailsXhrInProgress: true,
				loading: true
			};

		case COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL:
			return {
				...state,
				fetchCurrentMemberAddonDetailsErrorId: _.get(action, 'error.errorId'),
				fetchCurrentMemberAddonDetailsXhrInProgress: false,
				loading: false
			};


		case COMPANIES_PURCHASE_SEAT:
			return {
				...state,
				purchaseSeatsErrorId: null,
				purchaseSeatsSuccess: null,
				loading: true
			};
	
		case COMPANIES_PURCHASE_SEAT_FAIL:
			return {
				...state,
				purchaseSeatsErrorId: _.get(action, 'error.errorId'),
				loading: false
			};

		case ADDON_GET_DETAILS:
			return {
				...state,
				fetchAddonDetailsErrorId: null,
				fetchAddonDetailsSuccess: null,
				loading: true
			};
		
		case ADDON_GET_DETAILS_FAIL:
			return {
				...state,
				fetchAddonDetailsErrorId: _.get(action, 'error.errorId'),
				loading: false
			};
	
		case UPCOMING_INVOICE_GET_ESTIMATE:
			return {
				...state,
				getUpcomingInvoiceErorId: null,
				getUpcomingInvoiceSuccess: null,
				loading: true,
				upcomingInvoiceEstimationXhrInProgress: true
			};

		case UPCOMING_INVOICE_GET_ESTIMATE_FAIL:
			return {
				...state,
				getUpcomingInvoiceErorId: _.get(action, 'error.errorId'),
				loading: false,
				upcomingInvoiceEstimationXhrInProgress: false
			};

		case COMPANIES_CONTACT_SALES:
			return {
				...state,
				contactSalesSuccess: null,
				contactSalesErrorId: null,
				contactSalesXhrInProgress: true,
				loading: true
			};

		case COMPANIES_CONTACT_SALES_FAIL: 			
			return {
				...state,
				contactSalesErrorId: _.get(action, 'error.errorId'),
				contactSalesXhrInProgress: false,
				loading: false
			};


		case SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN: 
			return {
				...state,
				getSubscriptionEstimateActivePlanErrorId: null,
				getSubscriptionEstimateActivePlanSuccess: null,
				getSubscriptionEstimateActivePlanXhrInProgress: true,
				loading: true
			};
			
		case SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL:
			return {
				...state,
				getSubscriptionEstimateActivePlanErrorId: _.get(action, 'error.errorId'),
				getSubscriptionEstimateActivePlanXhrInProgress: false,
				loading: false
			};	

		case SUBSCRIPTION_GET_ESTIMATE:
			return {
				...state,
				getSubscriptionEstimateErrorId: null,
				getSubscriptionEstimateSuccess: null,
				getSubscriptionEstimateXhrInProgress: true,
				getSubscriptionEstimateUrl: action.payload.requestUrl,
				getSubscriptionEstimateForPlan: action.payload.currentPlanId,
				loading: true
			};
	
		case SUBSCRIPTION_GET_ESTIMATE_FAIL: {
			return {
				...state,
				getSubscriptionEstimateErrorId: _.get(action, 'error.errorId'),
				getSubscriptionEstimateXhrInProgress: false,
				getSubscriptionEstimateUrl: null,
				getSubscriptionEstimateForPlan: null,
				loading: false
			};			
		}

		case DISCOUNT_CLEAR_APPLIED:
			return {
				...state,
				getSubscriptionEstimateUrl: null,
				loading: false
			};

		case COMPANIES_USER_ADD:
			return {
				...state,
				addCompanyUsersErrorId: null,
				loading: true,
				...(action.payload.hasPlan && action.payload.targetUsersPayingQuantity &&
					{ pendingPayingUserQuantity: action.payload.targetUsersPayingQuantity })
			};			

		case COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION:
			return {
				...state,
				createChargeBeeSubscriptionErrorId: null,
				createChargeBeeSubscriptionSuccess: null,
				loading: true
			};				

		case COMPANIES_USERS_REDUCE_SUCCESS:
			return {
				...state,
				loading: false,
				batchReduceUsersSuccess: true,
				// clear state saved in Reduce users popup
				pendingReduceUsers: [],
			};

		case COMPANIES_USERS_REDUCE:
			return {
				...state,
				batchReduceUsersErrorId: null,
				batchReduceUsersSuccess: null,
				loading: true
			};


		case COMPANIES_USER_DELETE:
		case COMPANIES_USER_UPDATE:
		case COMPANIES_VALIDATE:
		case COMPANIES_ADD:
		case COMPANIES_ESTIMATE_USER_UPDATE:
		case COMPANIES_ESTIMATE_USER_DELETE:
		case COMPANIES_CREATE_CHARGEBEE_SESSION:
		case COMPANIES_INDUSTRIES_FETCH:
		case COMPANIES_SIZES_FETCH:
		case COMPANIES_COUNTRIES_FETCH:
		case USER_REGION_FETCH:
		case COMPANIES_FONT_ADD:
		case COMPANIES_FONT_REMOVE:
		case SEND_EMAIL:
			return {
				...state,
				loading: true
			};

		case COMPANIES_UPDATE: {
			return {
				...state,
				companyUpdatingErrorId: null,
				companyIsUpdating: true,
			};
		}

		case COMPANIES_UPDATE_SUCCESS: {
			const { companyId, data } = action.payload;

			let updatedPayingUserQuantity = 0;
			let subscriptionPlan = null;


			if (state.byId) {
				const { subscription, memberAddons } = getSubscriptionsAndAddons(state.byId[state.selectedId]);
				if (!_.isEmpty(memberAddons)) {
					memberAddons.forEach((addon) => {
						updatedPayingUserQuantity += addon.paidQuantity;
					});
				}

				if (!_.isEmpty(subscription)) {
					({ plan: subscriptionPlan } = convertPlanIdIntoSubscription(subscription.planId));
				}
			}

			let shouldDeletePendingState;
			if (subscriptionPlan &&
				state.pendingPayingUserQuantity &&
				state.pendingPayingUserQuantity <= 
				updatedPayingUserQuantity + PACKAGES_CONFIG[subscriptionPlan].freeSeatsIncluded) {
				shouldDeletePendingState = true;
			}

			// Preserve user's profile photo and external ids when doing the merge
			if (!_.isEmpty(state.byId[companyId])) {
				const existingUsers = state.byId[companyId].users;

				data.users.forEach((user, index, theArray) => {
					const oldUser = existingUsers.find(u => u.email === user.email);
					theArray[index].profilePhotoUri = user.profilePhotoUri || _.get(oldUser, 'profilePhotoUri');
					theArray[index].externalIds = user.externalIds || _.get(oldUser, 'externalIds');
				});
			}

			return {
				...state,
				...(shouldDeletePendingState && { pendingPayingUserQuantity: null }),
				byId: {
					...state.byId,
					[companyId]: {
						...state.byId[companyId],
						...data
					}
				},
				rawDataById: {
					...state.rawDataById,
					[companyId]: {
						...state.rawDataById[companyId],
						...data
					}
				},
				companyIsUpdating: false
			};
		}

		case COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS: {
			return {
				...state,
				paymentRedirectUrl: action.result['paymentRedirectUrl'],
				createChargeBeeSubscriptionErrorId: false,
				createChargeBeeSubscriptionSuccess: true,
				loading: false
			};
		}

		case COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL: {
			return {
				...state,
				paymentRedirectUrl: action.result['paymentRedirectUrl'],
				createChargeBeeSubscriptionErrorId: _.get(action, 'error.errorId'),
				createChargeBeeSubscriptionSuccess: false,
				loading: false
			};
		}

		case COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS:
		case COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL: {
			const { portal_session } = action.result;
			return {
				...state,
				portal_session,
				loading: false
			};
		}

		case COMPANIES_UPDATE_FAIL: {
			return {
				...state,
				companyIsUpdating: false,
				companyUpdatingErrorId: _.get(action, 'error.errorId'),
				loading: false
			};
		}

		case COMPANIES_VALIDATE_SUCCESS:
			return {
				...state,
				loading: false,
				valid: true
			};

		case COMPANIES_VALIDATE_FAIL:
			return {
				...state,
				loading: false,
				valid: false
			};

		case COMPANIES_ADD_SUCCESS:
			return {
				...state,
				allIds: [...state.allIds, action.result._id],
				byId: {
					...state.byId,
					[action.result._id]: getCompany({ ...action.result }, action.result.email)
				},
				rawDataById: {
					...state.rawDataById,
					[action.result._id]: getCompany({ ...action.result }, action.result.email)
				},
				selectedId: action.result._id,
				loading: false
			};

		case COMPANIES_REMOVE_SUCCESS: {
			const companyId = action.result;
			const index = findIndex(state.allIds, id => id === companyId);
			const selectedId = state.allIds[index - 1] || state.allIds[index + 1];
			return {
				...state,
				allIds: state.allIds.filter(id => id !== companyId),
				byId: omit(state.byId, companyId),
				rawDataById: omit(state.rawDataById, companyId),
				selectedId
			};
		}

		case COMPANIES_USER_ADD_FAIL:
			return {
				...state,
				addCompanyUsersErrorId: _.get(action, 'error.errorId'),
				loading: false,
				pendingPayingUserQuantity: 0
			};

		case COMPANIES_USERS_REDUCE_FAIL:
			return {
				...state,
				loading: false,
				batchReduceUsersErrorId: _.get(action, 'error.errorId'),
			};

		case COMPANIES_USER_UPDATE_FAIL:
		case COMPANIES_USER_DELETE_FAIL:
		case COMPANIES_ADD_FAIL:
		case COMPANIES_FONT_ADD_FAIL:
		case COMPANIES_FONT_REMOVE_FAIL:
		case COMPANIES_USER_ADD_SUCCESS:
		case COMPANIES_USER_UPDATE_SUCCESS:
		case REQUEST_FINISHED:
		case SEND_EMAIL_SUCCESS:
		case SEND_EMAIL_FAIL:
			return {
				...state,
				loading: false
			};
		
		case COMPANIES_USER_DELETE_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					[state.selectedId]: {
						...state.byId[state.selectedId],
						users: state.byId[state.selectedId].users.filter(user => user.email !== action.payload.email)
					}
				},
				rawDataById: {
					...state.rawDataById,
					[state.selectedId]: {
						...state.rawDataById[state.selectedId],
						users: state.rawDataById[state.selectedId].users.filter(user => user.email !== action.payload.email)
					}
				},
				loading: false
			};

		case USER_EXTERNAL_ID_UPDATE: {
			return {
				...state,
				updatingExternalIdXhrInProgress: [...state.updatingExternalIdXhrInProgress, action.payload.userId],
				updatingExternalIdErrorId: state.updatingExternalIdErrorId.filter(user => user.userId !== action.payload.userId),
				updatingExternalIdSuccess: state.updatingExternalIdSuccess.filter(userId => userId !== action.payload.userId)
			};
		}

		case USER_EXTERNAL_ID_UPDATE_FAIL: {
			return {
				...state,
				updatingExternalIdErrorId:
					[	...state.updatingExternalIdErrorId, 
						{ userId: action.payload.userId, errorId: _.get(action, 'error.errorId')}
					],
				updatingExternalIdXhrInProgress:
					state.updatingExternalIdXhrInProgress.filter(userId => userId !== action.payload.userId)
			};
		}

		case USER_EXTERNAL_ID_STATE_CLEAR: {
			return {
				...state,
				updatingExternalIdXhrInProgress: [],
				updatingExternalIdErrorId: [],
				updatingExternalIdSuccess: []
			};
		}

		case USER_EXTERNAL_ID_UPDATE_SUCCESS: {
			return {
				...state,
				updatingExternalIdSuccess: [...state.updatingExternalIdSuccess, action.payload.userId],
				updatingExternalIdXhrInProgress:
					state.updatingExternalIdXhrInProgress.filter(userId => userId !== action.payload.userId),
				byId: {
					...state.byId,
					[state.selectedId]: {
						...state.byId[state.selectedId],
						users: state.byId[state.selectedId].users.map(user => 
							user.userId === action.payload.userId
								?
								{ ...user, externalIds: action.payload.externalIds }
								:
								{...user })
					}
				},
				rawDataById: {
					...state.rawDataById,
					[state.selectedId]: {
						...state.rawDataById[state.selectedId],
						users: state.rawDataById[state.selectedId].users.map(user => 
							user.userId === action.payload.userId
								?
								{ ...user, externalIds: action.payload.externalIds }
								:
								{ ...user })
					}
				},
				loading: false
			};			
		}

		case COMPANIES_UPDATE_USER_PHOTO:
			return {
				...state,
				updatingUserPhotoInProgress: [...state.updatingUserPhotoInProgress, action.payload.userId],
				updatingUserPhotoErrorId: state.updatingUserPhotoErrorId.filter(user => user.userId !== action.payload.userId),
				updatingUserPhotoSuccess: state.updatingUserPhotoSuccess.filter(userId => userId !== action.payload.userId)
			};

		case COMPANIES_UPDATE_USER_PHOTO_FAIL:
			return {
				...state,
				updatingUserPhotoErrorId:
					[	...state.updatingUserPhotoErrorId, 
						{ userId: action.payload.userId, errorId: _.get(action, 'error.errorId')}
					],
				updatingUserPhotoInProgress:
					state.updatingUserPhotoInProgress.filter(userId => userId !== action.payload.userId)
			};

		case COMPANIES_UPDATE_USER_PHOTO_SUCCESS: {
			return {
				...state,
				updatingUserPhotoSuccess: [...state.updatingUserPhotoSuccess, action.payload.userId],
				updatingUserPhotoInProgress:
					state.updatingUserPhotoInProgress.filter(userId => userId !== action.payload.userId),
				byId: {
					...state.byId,
					[state.selectedId]: {
						...state.byId[state.selectedId],
						users: state.byId[state.selectedId].users.map(user => 
							user.userId === action.payload.userId
								?
								{ ...user, profilePhotoUri: action.result.profilePhotoThumbnailsURLs ?
									action.result.profilePhotoThumbnailsURLs.original : undefined }
								:
								{...user })
					}
				},
				rawDataById: {
					...state.rawDataById,
					[state.selectedId]: {
						...state.rawDataById[state.selectedId],
						users: state.rawDataById[state.selectedId].users.map(user => 
							user.userId === action.payload.userId
								?
								{ ...user, profilePhotoUri: action.result.profilePhotoThumbnailsURLs ?
									action.result.profilePhotoThumbnailsURLs.original : undefined }
								:
								{ ...user })
					}
				},
				loading: false
			};
		}

		case COMPANIES_CHANGE:
			return {
				...state,
				selectedId: action.result.company && action.result.company.id
			};

		case WORKSPACE_ADD_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					[state.selectedId]: {
						...state.byId[state.selectedId],
						workspaces: [
							...state.byId[state.selectedId].workspaces,
							action.result._id
						]
					}
				},
				rawDataById: {
					...state.rawDataById,
					[state.selectedId]: {
						...state.rawDataById[state.selectedId],
						workspaces: [
							...state.rawDataById[state.selectedId].workspaces,
							action.result._id
						]
					}
				}	
			};

		case WORKSPACE_DELETE_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					[state.selectedId]: {
						...state.byId[state.selectedId],
						workspaces: state.byId[state.selectedId].workspaces.filter(id => id !== action.result)
					}
				},
				rawDataById: {
					...state.rawDataById,
					[state.selectedId]: {
						...state.rawDataById[state.selectedId],
						workspaces: state.rawDataById[state.selectedId].workspaces.filter(id => id !== action.result)
					}
				}

			};

		case COMPANIES_INDUSTRIES_FETCH_SUCCESS:
			return {
				...state,
				industries: action.result,
				loading: false
			};

		case COMPANIES_SIZES_FETCH_SUCCESS:
			return {
				...state,
				sizes: action.result,
				loading: false
			};

		case USER_REGION_FETCH_SUCCESS: {
			if (window.location.href.indexOf('user-region') !== -1) {
				return {
					...state,
					userRegion: window.location.href.split('?')[1].replace('user-region=', '').toUpperCase(),
					loading: false
				};				
			} else {
				return {
					...state,
					userRegion: action.result.country.toUpperCase(),
					loading: false
				};
			}
		}

		case USER_REGION_FETCH_FAIL: {
			const hostName = window.location.hostname;

			if (window.location.href.indexOf('user-region') !== -1) {
				return {
					...state,
					userRegion: window.location.href.split('?')[1].replace('user-region=', '').toUpperCase(),
					loading: false
				};
			} else {
				if (hostName.indexOf('localhost') !== -1 || hostName.indexOf('staging') !== -1) {
					const demoCountryCodes = ['CA', 'US', 'GB', 'DE'];
					const randomCountryCode = demoCountryCodes[Math.floor(Math.random()*demoCountryCodes.length)];

					return {
						...state,
						userRegion: randomCountryCode,
						loading: false
					};
				} else {
					return {
						...state,
						userRegion: false,
						loading: false
					};
				}
			}
		}

		case COMPANIES_COUNTRIES_FETCH_SUCCESS:
			return {
				...state,
				countries: action.result,
				loading: false
			};

		case COMPANIES_ESTIMATE_SEAT_SUCCESS:
		case COMPANIES_ESTIMATE_USER_ADD_SUCCESS:
		case COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS:
		case COMPANIES_ESTIMATE_USER_DELETE_SUCCESS: {
			return {
				...state,
				loading: false
			};
		}

		case COMPANIES_PURCHASE_SEAT_SUCCESS: {
			return {
				...state,
				loading: false,
				purchaseSeatsSuccess: true,
				pendingPayingUserQuantity: action.payload.targetUsersPayingQuantity
			};
		}

		case ADDON_GET_DETAILS_SUCCESS: {
			return {
				...state,
				loading: false,
				fetchAddonDetailsSuccess: true,
				addonsDetails: action.result
			};
		}
		
		case COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS: {
			return {
				...state,
				loading: false,
				fetchCurrentMemberAddonDetailsSuccess: true,
				fetchCurrentMemberAddonDetailsXhrInProgress: false,
				// eslint-disable-next-line max-len
				currentMemberAddonDetails: {[`${getNonObsoleteMemberAddonForPlan(action.payload.plan)}-${action.payload.period}-${action.payload.currency}`]: action.result}
			};
		}			

		case COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS:
			return {
				...state,
				currentMemberAddonDetails: null
			};

		case UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS: {
			return {
				...state,
				loading: false,
				getUpcomingInvoiceSuccess: true,
				upcomingInvoiceEstimation: action.result,
				upcomingInvoiceEstimationXhrInProgress: false
			};
		}		

		case COMPANIES_CONTACT_SALES_SUCCESS:
			return {
				...state,
				contactSalesErrorId: null,
				contactSalesSuccess: true,
				contactSalesXhrInProgress: false,
				loading: false
			};

		case SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS: {
			return {
				...state,
				loading: false,
				getSubscriptionEstimateActivePlanErrorId: null,
				getSubscriptionEstimateActivePlanSuccess: true,
				getSubscriptionEstimateActivePlanXhrInProgress: false,
				subscriptionEstimationActivePlan: {
					...action.result
				}
			};				
		}

		case SUBSCRIPTION_GET_ESTIMATE_SUCCESS: {
			return state.getSubscriptionEstimateUrl === action.payload.requestUrl &&
				state.getSubscriptionEstimateForPlan === action.payload.currentPlanId
				?
				{
					...state,
					loading: false,
					getSubscriptionEstimateErrorId: false,
					subscriptionEstimation: {
						...action.result,
						// add current active plan from current state as it won't be requested
						// when sending coupon id / coupon set to estimation endpoint
						...(action.payload.currentPlanId !== 'all' &&
						_.get(state.subscriptionEstimation, '['+action.payload.currentPlanId+']') &&
							{[action.payload.currentPlanId] : state.subscriptionEstimation[action.payload.currentPlanId]})
					},
					getSubscriptionEstimateXhrInProgress: false
				}
				:
				{
					...state
				};
		}
				
		case COMPANIES_SETTING_WRITE: {
			const { companyId } = action.payload;
			return {
				...state,
				byId: {
					...state.byId,
					[companyId]: {
						...state.byId[companyId],
						companySettingsUpdateSuccess: null
					}
				},
				rawDataById: {
					...state.rawDataById,
					[companyId]: {
						...state.rawDataById[companyId],
						companySettingsUpdateSuccess: null
					}
				},
				loading: true
			};
		}

		case COMPANIES_SETTING_WRITE_SUCCESS: {
			const { newSettings, companyId } = action.payload;
			return {
				...state,
				byId: {
					...state.byId,
					[companyId]: {
						...state.byId[companyId],
						companySettingsUpdateSuccess: true,
						companySettingsUpdatingErrorId: null,
						settings: {
							...state.byId[companyId].settings,
							...newSettings
						}
					}
				},
				rawDataById: {
					...state.rawDataById,
					[companyId]: {
						...state.rawDataById[companyId],
						companySettingsUpdateSuccess: true,
						companySettingsUpdatingErrorId: null,
						settings: {
							...state.rawDataById[companyId].settings,
							...newSettings
						}

					}
				},
				loading: false
			};
		}

		case COMPANIES_SETTING_WRITE_FAIL: {
			const { companyId } = action.payload;
			return {
				...state,
				byId: {
					...state.byId,
					[companyId]: {
						...state.byId[companyId],
						companySettingsUpdateSuccess: false,
						companySettingsUpdatingErrorId: _.get(action, 'error.errorId'),
					}
				},
				rawDataById: {
					...state.rawDataById,
					[companyId]: {
						...state.rawDataById[companyId],
						companySettingsUpdatingErrorId: _.get(action, 'error.errorId'),

					}
				},
				loading: false
			};
		}
		
		case COMPANIES_INVITE_USER_ADD:
			return {
				...state,
				inviteUsers: [...state.inviteUsers, action.payload.user]
			};

		case COMPANIES_INVITE_USER_UPDATE:
			return {
				...state,
				inviteUsers: state.inviteUsers.map(user => {
					if (user.id === action.payload.user.id) {
						return {id: user.id, role: action.payload.user.role, email: action.payload.user.email};
					} else {
						return user;
					}
				})
			};

		case COMPANIES_INVITE_USER_REMOVE:
			return {
				...state,
				inviteUsers: [...state.inviteUsers.filter(user => user.id !== action.payload.id)]
			};
	
		case COMPANIES_INVITE_USER_MESSAGE_SET:
			return {
				...state,
				inviteUsersMessage: action.payload.message
			};

		case COMPANIES_INVITE_USER_CLEAR_USERS:
			return {
				...state,
				inviteUsers: []
			};
			
		case COMPANIES_INVITE_USER_CLEAR_MESSAGE:
			return {
				...state,
				inviteUsersMessage: null
			};
			
		case USER_REDUCE_UPDATE:
			return {
				...state,
				pendingReduceUsers: updateReducedUsers(
					state.pendingReduceUsers,
					action.payload.email,
					action.payload.userId,
					action.payload.externalIds,
					action.payload.action
				)
			};			
	
		default:
			return state;
	}
};


export const validateCompany = (name) => {
	return {
		types: [COMPANIES_VALIDATE, COMPANIES_VALIDATE_SUCCESS, COMPANIES_VALIDATE_FAIL],
		promise: client => client.get('/companies/validation', {
			params: { name }
		}).catch((error) => {
			const httpErrorProps = extractPropsforSuperagentHttpError(error);

			const nError = new AppError({
				message: 'companies.validateCompany() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_COMPANIES' }
			});

			throw nError;
		})
	};
};


export const addCompany = (data) => {
	return {
		types: [COMPANIES_ADD, REQUEST_FINISHED, COMPANIES_ADD_FAIL],
		promise: client => client.post('/companies', { data }).catch((error) => {
			const httpErrorProps = extractPropsforSuperagentHttpError(error);
			const nError = new AppError({
				message: 'companies.addCompany() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_COMPANIES' }
			});

			throw nError;
		})
	};
};


export const updateCompany = (companyId, clientData) => {
	//[P9052-11080] industry name is clientside only, do not send to server
	let data = _.omit(clientData, ['industry']);
	return (dispatch) => {
		return dispatch({
			types: [COMPANIES_UPDATE, REQUEST_FINISHED, COMPANIES_UPDATE_FAIL],
			payload: {
				companyId,
				clientData
			},
			promise: client => client.patch(`/companies/${companyId}`, {
				data: { data }
			}).then(() => {
				if (clientData && clientData.displayName) {
					document.title = 'Xara Workspace | ' + clientData.displayName;
				}
				showQuickMessage(localize('company-profile-updated')).call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.updateCompany() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const selectCompanies = companies => {
	return {
		type: COMPANIES_SET,
		result: { companies }
	};
};


export const changeCompany = company => {
	return {
		type: COMPANIES_CHANGE,
		result: { company }
	};
};


export const changeCompanyAndNotify = company => {
	return (dispatch, getState) => {
		if (company) {
			setItem('selectedCompany', company.id);
			dispatch(changeCompany(company));
		}

		const { companies } = getState();

		if (companies.selectedId && companies.rawDataById[companies.selectedId]) {
			setItem('selectedCompany', companies.selectedId);
			dispatch({
				type: COMPANIES_CHANGED,
				result: {
					company: companies.rawDataById[companies.selectedId]
				}
			});
		}
	};
};

// USERS

export const addCompanyUsers = (users, invitationMsg, hasPlan, targetUsersPayingQuantity) => {
	return (dispatch, getState) => {
		const { selectedId, rawDataById } = getState().companies;
		const displayName = rawDataById[selectedId].displayName;

		const postData = {
			users,
			host: XC_URL + `?company=${encodeURIComponent(displayName)}`,
			...(invitationMsg && { invitationMsg })
		};

		return dispatch({
			types: [COMPANIES_USER_ADD, COMPANIES_USER_ADD_SUCCESS, COMPANIES_USER_ADD_FAIL],
			payload: { 
				users,
				hasPlan,
				...(targetUsersPayingQuantity && {targetUsersPayingQuantity})
			},
			promise: client => client.post(`/companies/${selectedId}/users`, {
				data: postData
			}).then(() => {
				const nonGuestUsers = filterNonGuestUsers(users);
				if (nonGuestUsers.length > 0) {
					showQuickMessage(localize('users-user-added',
					nonGuestUsers.map(u => u.email).join(', '))).call(this, dispatch);
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.addCompanyUser() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const sendInviteToUsers = (users, invitationMsg, hasPlan, targetUsersPayingQuantity) => {
	return (dispatch, getState) => {
		const { selectedId, rawDataById } = getState().companies;
		const displayName = rawDataById[selectedId].displayName;

		if (!users || !users.length) {
			return showQuickMessage(localize('users-no-users-invited')).call(this, dispatch);
		}

		const postData = {
			users,
			host: XC_URL + `?company=${encodeURIComponent(displayName)}`,
			...(invitationMsg && { invitationMsg })
		};

		return dispatch({
			types: [COMPANIES_USER_ADD, COMPANIES_USER_ADD_SUCCESS, COMPANIES_USER_ADD_FAIL],
			payload: { 
				users,
				hasPlan,
				...(targetUsersPayingQuantity && {targetUsersPayingQuantity})
			},
			promise: client => client.post(`/companies/${selectedId}/users`, {
				data: postData
			}).then(() => {
				const nonGuestUsers = filterNonGuestUsers(users);
				if (nonGuestUsers.length > 0) {
					showQuickMessage(localize('users-users-invited',
					nonGuestUsers.length)).call(this, dispatch);
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.sendInviteToUsers() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const estimateCostOnAddCompanyUsers = usersParams => {
	let users = [];
	users.push(...usersParams);
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_ESTIMATE_USER_ADD, REQUEST_FINISHED, COMPANIES_ESTIMATE_USER_ADD_FAIL],
			payload: { users },
			promise: client => client.post(`/companies/${selectedId}/estimate/users`, {
				data: { users, host: XC_URL }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.estimateCostOnAddCompanyUsers() failed',
					errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const updateUserPhoto = (file, companyId, userId) => {
	return (dispatch, getState) => {
		const method = file ? 'post' : 'delete';
		let data = file ? new FormData() : undefined;

		if (file) {
			data.append('file', file);
			data = { data: data };
		} else {
			data = { data: { companyId, userId }};
		}

		return dispatch({
			types: [COMPANIES_UPDATE_USER_PHOTO, COMPANIES_UPDATE_USER_PHOTO_SUCCESS, COMPANIES_UPDATE_USER_PHOTO_FAIL],
			payload: { companyId, userId },
			promise: client => client[method](`/account/photo?companyId=${companyId}&userId=${userId}`, data
			).then((response) => {
				showQuickMessage(localize(file ? 'users-user-photo-updated' : 'users-user-photo-removed')).call(this, dispatch);
				return response;
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const errorId = httpErrorProps.errorId || ERRORS.UNKNOWN;

				showQuickMessage(localize(file ? 'users-user-photo-update-error' : 'users-user-photo-remove-error')).
					call(this, dispatch);

				const nError = new AppError({
					message: 'companies.updateUserPhoto() failed',
					errorId: errorId,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const updateCompanyUser = (data, updatedUser) => {
	return (dispatch, getState) => {
		if (Array.isArray(data)) {
			data = data.map(item => {
				item.trackingName && (delete item.trackingName);
				item.action && (delete item.action);
				return item;
			});
		}
		const { selectedId } = getState().companies;
		const { email, role } = updatedUser;

		return dispatch({
			types: [COMPANIES_USER_UPDATE, COMPANIES_USER_UPDATE_SUCCESS, COMPANIES_USER_UPDATE_FAIL],
			payload: { id: selectedId, data },
			promise: client => client.patch(`/companies/${selectedId}/users/${email}`, {
				data: { role, host: XC_URL }
			}).then(() => showQuickMessage(localize('users-user-role-updated'))(dispatch))
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.updateCompanyUser() failed',
						errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const estimateCostOnUpdateCompanyUser = (data, updatedUser) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		const { email, role } = updatedUser;
		return dispatch({
			types: [COMPANIES_ESTIMATE_USER_UPDATE, REQUEST_FINISHED, COMPANIES_ESTIMATE_USER_UPDATE_FAIL],
			payload: { id: selectedId, data },
			promise: client => client.patch(`/companies/${selectedId}/estimate/users/${email}`, {
				data: { role, host: XC_URL }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.estimateCostOnUpdateCompanyUser() failed',
					errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};


export const deleteCompanyUser = (email) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;

		return dispatch({
			types: [COMPANIES_USER_DELETE, REQUEST_FINISHED, COMPANIES_USER_DELETE_FAIL],
			payload: { email },
			promise: client => client.delete(`/companies/${selectedId}/users/${email}`)
				.then(() => {
					showQuickMessage(localize('users-user-removed', email)).call(this, dispatch);
				}).catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.deleteCompanyUser() failed',
						errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const estimateCostOnDeleteCompanyUser = email => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_ESTIMATE_USER_DELETE, REQUEST_FINISHED, COMPANIES_ESTIMATE_USER_DELETE_FAIL],
			payload: { email },
			promise: client => client.delete(`/companies/${selectedId}/estimate/users/${email}`)
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.estimateCostOnDeleteCompanyUser() failed',
						errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const updateUserExternalId = (companyId, userId, externalIds) => {
	return (dispatch) => {
		return dispatch({
			types: [USER_EXTERNAL_ID_UPDATE, USER_EXTERNAL_ID_UPDATE_SUCCESS, USER_EXTERNAL_ID_UPDATE_FAIL],
			payload: {
				companyId,
				userId,
				externalIds
			},
			promise: client => client.patch(ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT, {
				data: { companyId, userId, externalIds }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.updateUserExternalId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const clearExternalIdState = () => {
	return { type: USER_EXTERNAL_ID_STATE_CLEAR };
};

// SOCKET EVENTS

export const connectCompanySocketEvents = () => {

	return (dispatch, getState) => {
		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:added',
			callback: COMPANIES_ADD_SUCCESS
		});

		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:updated',
			callback: payload => {
				dispatch({
					type: COMPANIES_UPDATE_SUCCESS,
					payload: {
						companyId: payload._id,
						data: getCompany(payload, getState().session.user.mainEmail)
					}
				});

			}
		});

		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:removed',
			callback: COMPANIES_REMOVE_SUCCESS
		});

	};
};

export const fetchCompaniesIndustries = () => {
	return {
		types: [COMPANIES_INDUSTRIES_FETCH, COMPANIES_INDUSTRIES_FETCH_SUCCESS, COMPANIES_INDUSTRIES_FETCH_FAIL],
		promise: () => {
			return new Promise((resolve, reject) => {
				StaticResource.get(STATIC_RESOURCE_INDUSTRIES_PATH)
					.then(response => {
						resolve(response.data.industries);
					})
					.catch(error => {
						reject(error);
					});
			});
		}
	};
};

export const fetchCompaniesSizes = () => {
	return {
		types: [COMPANIES_SIZES_FETCH, COMPANIES_SIZES_FETCH_SUCCESS, COMPANIES_SIZES_FETCH_FAIL],
		promise: () => {
			return new Promise((resolve, reject) => {
				StaticResource.get(STATIC_RESOURCE_SIZES_PATH)
					.then(response => {
						resolve(response.data.sizes);
					})
					.catch(error => {
						reject(error);
					});
			});
		}
	};
};

export const fetchCompaniesCountries = () => {
	return {
		types: [COMPANIES_COUNTRIES_FETCH, COMPANIES_COUNTRIES_FETCH_SUCCESS, COMPANIES_COUNTRIES_FETCH_FAIL],
		promise: () => {
			return new Promise((resolve, reject) => {
				StaticResource.get(STATIC_RESOURCE_COUNTRIES_PATH)
					.then(response => {
						resolve(response.data.countries);
					})
					.catch(error => {
						reject(error);
					});
			});
		}
	};
};

export const fetchUserRegion = () => {
	return {
		types: [USER_REGION_FETCH, USER_REGION_FETCH_SUCCESS, USER_REGION_FETCH_FAIL],
		promise: client => client.get(COUNTRY_DETECTION_ENDPOINT).catch((error) => {
			const httpErrorProps = extractPropsforSuperagentHttpError(error);
			const nError = new AppError({
				message: 'user.fetchUserRegion() failed',
				errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_USER' }
			});

			throw nError;
		})
	};
};


/**
 * Create the ChargeBee session
 *
 * @param {string} planid plan details
 * in format: team-[payment period]-[payment currency] (for example, team-monthly-usd)
 * @returns portal-session
 */
export const createChargeBeeSession = (planid) => {
	return (dispatch, getState) => {
		const { companies } = getState();
		const { selectedId } = companies;
		return dispatch({
			types: [
				COMPANIES_CREATE_CHARGEBEE_SESSION,
				COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS,
				COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL],
			promise: client => client.get('/payment/chargebee/portal-session', {
				params: { 'id': selectedId, planid }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.createChargeBeeSession() failed',
					errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

/**
 * Create the ChargeBee Subscription
 *
 * @param {string} chargebee_plan_or_addon_id plan details
 * in format: team-[payment period]-[payment currency] (for example, team-monthly-usd)
 * @param {bool} upgrade whether this is an upgrade of an existing subscription or not.
 * @param {string} host host for redirection after the subscription is created without GET attributes
 * @param {string} couponSetId coupon set id, MW will skip it if couponId is also set in same request
 * @param {string} couponId coupon id
 * @param {string} host host for redirection after the subscription is created without GET attributes
 * @returns dispatch
 */
export const createChargeBeeSubscription = (
	hasPlan,
	chargebee_plan_or_addon_id,
	upgrade = false,
	host = window.location.href.split('?')[0],
	couponSetId,
	couponId,
	isAddon,
	itemsNumber,
	lang) => {

	return (dispatch, getState) => {
		const { companies } = getState();
		const { plan } = convertPlanIdIntoSubscription(chargebee_plan_or_addon_id);

		return dispatch({
			types: [
				COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION,
				COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS,
				COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL],

			payload: { 
				couponId,
				couponSetId
			},

			promise: client => client.get(`/companies/${companies.selectedId}/${isAddon ? 'addon' : 'subscription'}`, {
				params: { 
					[`chargebee-${isAddon ? 'addon' : 'plan'}-id`]: chargebee_plan_or_addon_id,
					host,
					...(lang && { locale: lang }),
					...(upgrade === true && { upgrade: true }),
					...(couponSetId && { couponSetId: encodeURIComponent(couponSetId) }),
					...(couponId && { couponId: encodeURIComponent(couponId) }),
					// Use 'quantity param when purchasing perpetual addon or extra seats
					...(!upgrade && itemsNumber && (isAddon || hasPlan) && { quantity: itemsNumber }),
					// During upgrade of RE plans use 'numberOfUsers' param
					...(upgrade && itemsNumber && plan === SUBSCRIPTION_PLAN.BROKERAGES && { numberOfUsers: itemsNumber }),
					// During initial purchase of subscription use 'numberOfUsers' param
					...(!isAddon && !hasPlan && itemsNumber && { numberOfUsers: itemsNumber })
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);

				let errorId;
				if (httpErrorProps.errorId &&
					(couponId || couponSetId) &&
					httpErrorProps.errorId === ERRORS.PAYMENT_PROVIDER_INTERNAL_ERROR) {
					errorId = ERRORS.PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR;
				} else {
					errorId = httpErrorProps.errorId || ERRORS.UNKNOWN;
				}

				const nError = new AppError({
					errorId,
					message: `companies.createChargeBeeSubscription() failed for ${isAddon ? 'addon':'subscription'}`,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				if (errorId === ERRORS.PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR) {
					const { plan } = convertPlanIdIntoSubscription(chargebee_plan_or_addon_id);

					const payload = {
						productType: isAddon ? 'perpetual' : 'subscription',
						lang: i18n.getCurrentLanguage(),
						coupon: couponId || couponSetId,
						email: getState().session.user.mainEmail,
						type: isAddon ||
							[SUBSCRIPTION_PLAN.PHOTO, SUBSCRIPTION_PLAN.WEB, SUBSCRIPTION_PLAN.DESIGNER].includes(plan)
							?
							'desktop' : 'cloud'
					};
					sendCurrentOfferToUser(payload);
				}

				throw nError;
			})
		});
	};
};

/**
 * Retrieves the active company id from the URL or session data or localstorage
 */
export const getActiveCompanyId = () => {
	// P9052-18959 Open the company admin panel to the last selected team for this environment
	// It's very possible that the specific property doesn't exist so be defensive - e.g no user, no company, no settings

	const activeCompanyId = resolveActiveCompanyId(true);

	return {
		type: COMPANIES_GET_ACTIVE_COMPANY_ID,
		payload: activeCompanyId
	};
};

export const resolveActiveCompanyId = (useUrl) => {
	const { rawDataById } = store.getState().companies || {};
	const allRawIds = rawDataById ? Object.keys(rawDataById) : [];

	return (useUrl && getCompanyIdFromURL()) ||
	_.get(store.getState(), 'session.user.settings.home.companyId') ||
	getValidCompanyIdFromStorage() ||
	allRawIds[0];
};

/**
 * If company from browser storage is part of existing account then return it, otherwise ignore it
*/
export const getValidCompanyIdFromStorage = () => {
	let result = null;
	const { rawDataById } = store.getState().companies || {};
	const allRawIds = rawDataById ? Object.keys(rawDataById) : [];

	const companyIdFromStorage = getItem('selectedCompany');
	if (companyIdFromStorage && allRawIds.includes(companyIdFromStorage)) {
		result = companyIdFromStorage;
	}

	return result;
};

export const addCompanyFont = (data, replaceMode) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_FONT_ADD, REQUEST_FINISHED, COMPANIES_FONT_ADD_FAIL],
			promise: client => client.post(`/companies/${selectedId}/font`, { data }).then(() => {
				const { name } = data.get('font');
				const message = localize(replaceMode ? 'fonts-replaced' : 'fonts-added', name.toLowerCase());
				showQuickMessage(message).call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);

				const nError = new AppError({
					message: 'companies.addCompanyFont() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const removeCompanyFont = font => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		const { internalFontId } = font;
		return dispatch({
			types: [COMPANIES_FONT_REMOVE, REQUEST_FINISHED, COMPANIES_FONT_REMOVE_FAIL],
			promise: client => client.delete(`/companies/${selectedId}/font/${internalFontId}`).then(() => {
				showQuickMessage(localize('fonts-removed', internalFontId)).call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.removeCompanyFont() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const updateSmartFields = (smartfields) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_SMART_FIELDS_UPDATE, REQUEST_FINISHED, COMPANIES_SMART_FIELDS_UPDATE_FAIL],
			promise: client => client.post(`/companies/${selectedId}/smartfields`, { data: { smartfields } })
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.updateSmartFields() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})	
		});
	};
};

/**
 * Send request to trigger Email notification
 *
 * @param {string} type type of Email to send
 * @param {string} quickMessage a quick message text for notifing a user about the result of operation
 * @param {string} host host (URL) for an action button in the Email
 * @returns dispatch
 */
export const sendEmailNotification = (type, quickMessage = '', host = window.location.href) => {
	return (dispatch, getState) => {
		const { companies } = getState();
		return dispatch({
			types: [
				SEND_EMAIL,
				SEND_EMAIL_SUCCESS,
				SEND_EMAIL_FAIL],
			promise: client => client.get(`/companies/${companies.selectedId}/request`, {
				params: { type, host }
			}).then(() => {
				showQuickMessage(quickMessage).call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.sendEmailNotification() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

/**
 * Dispatches a redux action with a promise that will write the company settings to the middleware
 *
 * @param {Function} dispatch provided by Redux' mapDispatchToProps
 * @param {Object} settings the new company settings to be stored on the middleware
 */
export const writeCompanySettings = (newSettings) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_SETTING_WRITE, COMPANIES_SETTING_WRITE_SUCCESS, COMPANIES_SETTING_WRITE_FAIL],
			payload: {
				companyId: selectedId,
				newSettings
			},
			promise: client => client.patch(`/companies/${selectedId}/settings`, { data: { settings: newSettings } })
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);

					const nError = new AppError({
						message: 'companies.writeCompanySettings() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_SESSION' }
					});

					throw nError;
				})
		});
	};
};

export const inviteUserUpdate = (user) => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_UPDATE,
			payload: { user }
		});
	};
};

export const inviteUserAdd = (user) => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_ADD,
			payload: { user }
		});
	};
};

export const inviteUserRemove = (id) => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_REMOVE,
			payload: { id }
		});
	};
};

export const inviteUserSetMessage = (message) => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_MESSAGE_SET,
			payload: { message }
		});
	};
};

export const inviteUsersClearUsers = () => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_CLEAR_USERS
		});
	};
};

export const inviteUsersClearMessage = () => {
	return dispatch => {
		dispatch({
			type: COMPANIES_INVITE_USER_CLEAR_MESSAGE
		});
	};
};

export const updatePendingReduceUser = (email, userId, externalIds, action) => {
	return dispatch => {
		dispatch({
			type: USER_REDUCE_UPDATE,
			payload: { email, userId, externalIds, action }
		});
	};
};

export const batchReduceUsers = (users) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;

		return dispatch({
			types: [COMPANIES_USERS_REDUCE, COMPANIES_USERS_REDUCE_SUCCESS, COMPANIES_USERS_REDUCE_FAIL],
			payload: { users },
			promise: client => {
				const promises = [];

				users.forEach((user) => {
					const { email, role, userId, externalIds } = user;
		
					if (user.action === REDUCE_ACTION.CHANGE_TO_GUEST) {
						promises.push(client.patch(`/companies/${selectedId}/users/${email}`, {data: { role, host: XC_URL }}));	
						
						!_.isEmpty(externalIds) &&
						userId &&
						promises.push(client.patch(
							ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT, { data: { companyId: selectedId, userId, externalIds: [] }})
						);

					} else if (user.action === REDUCE_ACTION.REMOVE) {
						promises.push(client.delete(`/companies/${selectedId}/users/${email}`));
					}
				});

				return Promise.all(promises)
					.catch((error) => {
						const httpErrorProps = extractPropsforSuperagentHttpError(error);

						const nError = new AppError({
							message: 'companies.batchReduceUsers() failed',
							errorId: ERRORS.UNKNOWN,
							originalError: new HttpError(httpErrorProps),
							visualisers: { feature: 'REDUX_SESSION' }
						});

						throw nError;
					});				
		
			}

		});
	};
};

export const estimateCostOnAddUserSeats = quantity => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_ESTIMATE_SEAT, REQUEST_FINISHED, COMPANIES_ESTIMATE_SEAT_FAIL],
			payload: { quantity },
			promise: client => client.post(`/companies/${selectedId}/licenses/members/estimate`, {
				data: { quantity }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.estimateCostOnAddUserSeats() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const purchaseSeats = (quantity, targetUsersPayingQuantity) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [COMPANIES_PURCHASE_SEAT, COMPANIES_PURCHASE_SEAT_SUCCESS, COMPANIES_PURCHASE_SEAT_FAIL],
			payload: { quantity, targetUsersPayingQuantity },
			promise: client => client.post(`/companies/${selectedId}/licenses/members`, {
				data: { quantity }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'companies.purchaseSeats() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

/**
 * Send request to get CB addons details
 *
 * @param {array} addonId addon id in format members-annual-usd
 * @returns dispatch
 */
export const fetchAddonDetails = (addonIds) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		
		const addonIdQueryString = addonIds.reduce(
			(accumulator, currentValue) => `${accumulator}&addonIds[]=${currentValue}`, 
		'');

		return dispatch({
			types: [
				ADDON_GET_DETAILS,
				ADDON_GET_DETAILS_SUCCESS,
				ADDON_GET_DETAILS_FAIL],
			promise: client => client.get(`/payment/chargebee/addonDetails?id=${selectedId}${addonIdQueryString}`)
				.then(response => {
					const result = {};
					const planKeys = Object.keys(response);

					planKeys.forEach(key => {
						if (response[key].addon) { // check if it contains errorId or addon data
							result[key] = response[key].addon;
						} else if (response[key].errorId) {
							const nError = new AppError({
								message: `fetchAddonDetails failed for addonId ${key}`,
								errorId: response[key].errorId,
								errorDetails: response[key],
								visualisers: { feature: 'REDUX_ADDON' }
							});
							log.send(nError);							
						}
					});
					
					return result;
				})			
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.fetchAddonDetails() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_ADDON' }
					});

					throw nError;
				})
		});
	};
};

/**
 * Fetch member addon details for addon in paymmentAccount
 * @returns dispatch
 */

export const fetchCurrentMemberAddonDetails = (plan, period, currency) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [
				COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS,
				COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS,
				COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL],
			payload: { plan, period, currency },
			promise: client => client.post(`/companies/${selectedId}/licenses/members/estimate`, {
				data: { quantity: 1 }
			})
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.fetchCurrentMemberAddonDetails() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});
	
					throw nError;
				})
		});
	};
};

export const clearMemberaddonDetails = () => {
	return dispatch => {
		dispatch({
			type: COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS
		});
	};
};

/**
 * Send request to get upcoming invoice estimate
 * Does not require any details (coupon, member addon id etc), only company ID
 * @returns dispatch
 */
export const getUpcomingInvoiceEstimate = () => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [
				UPCOMING_INVOICE_GET_ESTIMATE,
				UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS,
				UPCOMING_INVOICE_GET_ESTIMATE_FAIL],
			promise: client => client.get(`/companies/${selectedId}/upcomingInvoiceEstimation`)
				.then(response => {
					return response.renewalEstimation;
				})			
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'companies.getUpcomingInvoiceEstimate() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

/**
 * Show error message in case of "429 Too many requests error" from CB
 */
export const showRateLimitError = (message) => {
	return dispatch => {
		dispatch({
			type: ERROR_HANDLER_SET,
			error: {
				errorId: ERRORS.API_REQUEST_LIMIT_EXCEEDED
			}
		});
	};
};

/**
 * Show "package discontinued" error
 */
export const showErrorPopup = (errorId) => {
	return dispatch => {
		dispatch({
			type: ERROR_HANDLER_SET,
			error: {
				errorId
			}
		});
	};
};

/**
 * Show "rate limit" error
 */
export const showPackageDiscontinuedMessage = (message) => {
	return dispatch => {
		dispatch({
			type: ERROR_HANDLER_SET,
			error: {
				errorMessage: localize('error-message-discontinued-plan'),
				errorId: ERRORS.FAILED_TO_CREATE_COMPANY_SUBSCRIPTION
			}
		});
	};
};

/**
 * This endpoint should be used by companies with active or inactive subscription (plan in paymentAccount exists),
 * when a user wants to buy a subscription for first time or when a user wants to upgrade a subscription. 
 * In this case request url contains companyId.
 * 
 * This endpoint should be used when a user wants to buy a subscription for first time and paymentAccount is empty
 * Endpoint returns same numbers for all companies and they are cached by MW/Nginx.
 * In this case request url does not contain companyId.
 * @param {string} requestUrl
 * @param {string} currentPlanId
 * @param {string} couponId
 * @param {string} couponSetId
 * @param {boolean} onlyActivePlan
 * @returns dispatch
*/

export const getSubscriptionEstimation = 
		(requestUrl,
			currentPlanId,
			discountType,
			couponSetKey,
			couponId,
			couponSetId,
			couponType,
			onlyActivePlan) => {
			return (dispatch, getState) => {

				return dispatch({
					types: onlyActivePlan ?
						[
							SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN,
							SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS,
							SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL
						]
						:
						[
							SUBSCRIPTION_GET_ESTIMATE,
							SUBSCRIPTION_GET_ESTIMATE_SUCCESS,
							SUBSCRIPTION_GET_ESTIMATE_FAIL
						],
					payload: { 
						requestUrl,
						currentPlanId,
						couponId,
						couponSetId,
						discountType,
						couponSetKey,
						couponType,
					},
					
					promise: client => client.get(requestUrl)
						.catch((error) => {
							const httpErrorProps = extractPropsforSuperagentHttpError(error);
							const nError = new AppError({
								message: 
									`companies.getSubscriptionEstimation() ${onlyActivePlan ? 'for active plan' : ''} failed`,
								errorId: ERRORS.UNKNOWN,
								originalError: new HttpError(httpErrorProps),
								visualisers: { feature: 'REDUX_COMPANIES' }
							});

							throw nError;
						})
				});

			};
		};

export const sendContactSalesRequest = (data) => {
	return {
		types: [COMPANIES_CONTACT_SALES, COMPANIES_CONTACT_SALES_SUCCESS, COMPANIES_CONTACT_SALES_FAIL],
		promise: client => client.post(CONTACT_SALES.API_ENDPOINT, data)
			.catch((error) => {
				const httpErrorProps = extractPropsforAxiosHttpError(error);
				const nError = new AppError({
					message: 'companies.sendContactSalesRequest() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
	};
};



// WEBPACK FOOTER //
// ./src/redux/modules/companies.js